import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../BasketPxDetailsStyled';
import { rem } from 'polished';

export const BasketPxDetailsDS = styled(BasketPxDetailsStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .sections {
        background: ${({ theme }) => theme.colors.white};
        .leftSection,
        .rightSection {
            border: 1px solid ${({ theme }) => theme.colors.grey16};
            border-radius: ${rem(8)};
            &:hover,
            &:focus-visible {
                border-color: ${({ theme }) => theme.colors.secondary};
                background: none !important;
                .inner {
                    border-color: ${({ theme }) => theme.colors.secondary};
                }
            }

            &.selected {
                background: ${({ theme }) => theme.colors.grey4};
                border: 2px solid ${({ theme }) => theme.colors.secondary};
            }

            .title {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};

                .icon {
                    border-color: ${({ theme }) => theme.colors.black};

                    .selected {
                        width: ${rem(14)};
                        height: ${rem(14)};
                        top: ${rem(4)};
                        left: ${rem(4)};
                    }
                }
            }

            .description {
                font-size: ${({ theme }) => theme.fontSizes.h6};
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .description {
        .link {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .detailTitle {
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }

    .detail {
        .rightSection {
            button {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
        }
    }

    .footer {
        .label {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }

        .description {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.grey29};
        }
    }

    .continue {
        .continueLabel {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }

    .status {
        background: ${({ theme }) => theme.colors.grey4};
        border-radius: ${rem(8)};

        .statusIcon {
            svg {
                top: ${rem(35)};
            }
        }

        .statusLabel {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            line-height: ${rem(20)};
        }

        .trash {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            svg {
                margin-bottom: ${rem(-3)};
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }
    }

    .summary {
        .leftSection,
        .rightSection {
            background: ${({ theme }) => theme.colors.grey4};
            border-radius: ${rem(8)};
            color: ${({ theme }) => theme.colors.black};

            .summaryValue {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }

            .summaryDescription {
                font-size: ${({ theme }) => theme.fontSizes.h6};
                color: ${({ theme }) => theme.colors.grey29};
            }
        }
    }
`;
